import { ILLEGAL_ATTACH_PARENT_STATE, ILLEGAL_HIERARCHY_STATE, ILLEGAL_MERGE_STATE } from '../constants/error-messages';
export class HierarchyNode {
    constructor(selfNode) {
        this.children = new Set();
        this.isElderBrother = false;
        this.self = selfNode;
    }
    static linkParentAndChild(parentNode, childNode) {
        parentNode.addChild(childNode);
        childNode.attachToParent(parentNode);
    }
    static linkSibling(leftNode, rightNode) {
        leftNode.addAsRightSibling(rightNode);
        rightNode.addAsLeftSibling(leftNode);
    }
    attachToParent(parentNode, reset = false) {
        if (this.parent && !reset) {
            throw new Error(ILLEGAL_ATTACH_PARENT_STATE);
        }
        this.parent = parentNode;
    }
    getParent() {
        return this.parent;
    }
    addChild(childNode) {
        if (this.children.has(childNode)) {
            return;
        }
        this.children.add(childNode);
    }
    walkUp(callback) {
        // 同级遍历
        this.walkSiblings((hierarchyNode) => {
            callback(hierarchyNode.getSelfNode());
        });
        // 向上递归遍历父节点
        const elderBrother = this.getElderBrother();
        const parent = elderBrother.getParent();
        if (parent) {
            parent.walkUp(callback);
        }
    }
    walkDown(callback) {
        // 同级遍历
        this.walkSiblings((hierarchyNode) => {
            callback(hierarchyNode.getSelfNode());
        });
        // 向下递归，遍历所有子节点
        const elderBrother = this.getElderBrother();
        const children = elderBrother.getChildren();
        if (children.size > 0) {
            children.forEach((hierarchyNode) => hierarchyNode.walkDown(callback));
        }
    }
    /**
     * @param toNode
     */
    mergeTo(toNode) {
        if (this.getParent()) {
            throw new Error(ILLEGAL_MERGE_STATE);
        }
        // TODO 检查两个链表是否重合
        // 选举老大哥节点
        const elderBrother = toNode.getElderBrother();
        // 废除其他老大哥节点，将所有孩子节点合入到新的老大哥节点
        this.walkSiblings((hierarchyNode) => {
            // 链接新的父子关系
            hierarchyNode.setElderBrother(false);
            hierarchyNode.getChildren().forEach((childHierarchyNode) => {
                childHierarchyNode.attachToParent(elderBrother, true);
                elderBrother.addChild(childHierarchyNode);
            });
            // 删除原有父子关系
            hierarchyNode.removeChildren();
        });
        // 两个链表链接起来，能够相互访问
        const linkedRightNode = toNode.getRightTailSiblingNode();
        toNode.getRightTailSiblingNode().addAsRightSibling(this.getLeftHeadSiblingNode());
        this.getLeftHeadSiblingNode().addAsLeftSibling(linkedRightNode);
    }
    getChildren() {
        return this.children;
    }
    removeChildren() {
        this.children.clear();
    }
    addAsLeftSibling(siblingNode) {
        if (!this.leftSibling) {
            this.leftSibling = siblingNode;
        }
        else {
            const preLeftSiblingNode = this.getLeftHeadSiblingNode();
            preLeftSiblingNode === null || preLeftSiblingNode === void 0 ? void 0 : preLeftSiblingNode.addAsLeftSibling(siblingNode);
        }
    }
    addAsRightSibling(siblingNode) {
        if (!this.rightSibling) {
            this.rightSibling = siblingNode;
        }
        else {
            const preRightSiblingNode = this.getRightTailSiblingNode();
            preRightSiblingNode.addAsRightSibling(siblingNode);
        }
    }
    getLeftSibling() {
        return this.leftSibling;
    }
    getRightSibling() {
        return this.rightSibling;
    }
    isSelfElder() {
        return this.isElderBrother;
    }
    setElderBrother(isElder) {
        this.isElderBrother = isElder;
    }
    getSelfNode() {
        return this.self;
    }
    getLeftHeadSiblingNode() {
        let preLeftSiblingNode = this.getLeftSibling();
        if (!preLeftSiblingNode) {
            return this;
        }
        while (preLeftSiblingNode === null || preLeftSiblingNode === void 0 ? void 0 : preLeftSiblingNode.getLeftSibling()) {
            preLeftSiblingNode = preLeftSiblingNode === null || preLeftSiblingNode === void 0 ? void 0 : preLeftSiblingNode.getLeftSibling();
        }
        return preLeftSiblingNode || this;
    }
    getRightTailSiblingNode() {
        let preRightSiblingNode = this.getRightSibling();
        if (!preRightSiblingNode) {
            return this;
        }
        while (preRightSiblingNode === null || preRightSiblingNode === void 0 ? void 0 : preRightSiblingNode.getRightSibling()) {
            preRightSiblingNode = preRightSiblingNode === null || preRightSiblingNode === void 0 ? void 0 : preRightSiblingNode.getRightSibling();
        }
        return preRightSiblingNode || this;
    }
    getElderBrother() {
        let elderBrotherNode;
        this.walkSiblings((hierarchyNode) => {
            if (hierarchyNode.isSelfElder() || hierarchyNode.getParent()) {
                if (elderBrotherNode) {
                    throw new Error(ILLEGAL_HIERARCHY_STATE);
                }
                elderBrotherNode = hierarchyNode;
            }
        });
        return elderBrotherNode || this;
    }
    walkSiblings(callback) {
        // 当遍历没有发送时返回false
        callback(this);
        let curLeftSibling = this.leftSibling;
        while (curLeftSibling) {
            callback(curLeftSibling);
            curLeftSibling = curLeftSibling.getLeftSibling();
        }
        let curRightSibling = this.rightSibling;
        while (curRightSibling) {
            callback(curRightSibling);
            curRightSibling = curRightSibling.getRightSibling();
        }
    }
}
//# sourceMappingURL=hierarchy.js.map